import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

import Button from "react-bootstrap/Button";

import "./dropzone.scss";

export default function Dropzone({ handleUpload, size, withRadius }) {
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        // Do whatever you want with the file contents
        // const binaryStr = reader.result;
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [],
    },
    onDrop: (acceptedFiles) => {
      handleUpload(
        acceptedFiles.map((file) =>
          Object.assign(file, { preview: URL.createObjectURL(file) }),
        ),
      );
    },
  });

  return (
    <div
      {...getRootProps()}
      id="dropzone"
      className={`${size ? `dropzone-${size}` : ""} ${withRadius ? "dropzone-radius" : ""}`}
    >
      <input {...getInputProps()} />
      <Button variant="default" className="btn-upload">
        Click or drop image
      </Button>
    </div>
  );
}
